module.exports = __webpack_public_path__ + "static/qoutes-en-2b6465bbb6ebc6b30b25baab9160c3f6.png";